import { inject, Pipe, PipeTransform } from '@angular/core';
import {
  CT_KWH_TO_EUR_MWH_FACTOR,
  PriceConversionService,
} from '../services/price-conversion.service';

export { CT_KWH_TO_EUR_MWH_FACTOR, PriceConversionService };

@Pipe({
  name: 'convertPrice',
})
export class ConvertPricePipe implements PipeTransform {
  private priceConversionService = inject(PriceConversionService);

  transform(value: number, showEurMwh: boolean): number;
  transform(value: number | undefined | null, showEurMwh: boolean): number | undefined | null;
  transform(value: number | undefined | null, showEurMwh: boolean): number | undefined | null {
    return this.priceConversionService.convertPrice(value, showEurMwh);
  }
}
